<template>
    <div>
        <div class="section inclusivity"> 
            <div class="main_content">
                <div class="container">
                    <div class="heading_section">
                        <h2 class="text-left mb-0"  data-aos="fade-up">{{this.inclusivity.title}}</h2> 
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content ml-auto mb-md-0 mb-4">
                            <div class="custom_border ml-auto">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText[0]}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content mt--150 mb-md-0 mb-4">
                            <div class="custom_border">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText1[0]}}
                                </p>
                                <ul>
                                    <li  data-aos="fade-up"> {{this.inclusivity.RichText2[0]}}</li>
                                    <li  data-aos="fade-up"> {{this.inclusivity.RichText2[1]}}</li>
                                    <li  data-aos="fade-up"> {{this.inclusivity.RichText2[2]}}</li>
                                    <li  data-aos="fade-up"> {{this.inclusivity.RichText2[3]}}</li>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <div class="heading_section">
                        <h2 class="text-left mt-30 mb-0"  data-aos="fade-up">{{this.inclusivity.title2}}</h2> 
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content ml-auto mb-md-0 mb-4">
                            <div class="custom_border ml-auto">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText3[0]}}
                                </p>
                               
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 full-content">
                            <div class="custom_border">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText3[1]}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="row phase">
                        <div class="col-md-6 mb-md-0 mb-4 mx-auto mx-500">
                            <h4  data-aos="fade-up">{{this.inclusivity.phases[0]}}</h4>
                            <div class="custom_border">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText4[0]}}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 mb-md-0 mb-4 mx-auto mx-500">
                            <h4  data-aos="fade-up">{{this.inclusivity.phases[1]}}</h4>
                            <div class="custom_border">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText4[1]}}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 mb-md-0 mb-4 mx-auto mx-500">
                            <h4  data-aos="fade-up">{{this.inclusivity.phases[2]}}</h4>
                            <div class="custom_border">
                                <p  data-aos="fade-up">
                                    {{this.inclusivity.RichText4[2]}}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 mb-md-0 mb-4 mx-auto mx-500">
                            <h4  data-aos="fade-up">{{this.inclusivity.phases[3]}}</h4>
                            <div class="custom_border">
                                <p>
                                    {{this.inclusivity.RichText4[3]}}
                                </p>
                            </div>
                        </div>
                        <div class="col-md-6 mb-md-0 mb-4 mx-auto mx-500">
                            <h4  data-aos="fade-up">{{this.inclusivity.phases[4]}}</h4>
                            <div class="custom_border">
                                <p>
                                    {{this.inclusivity.RichText4[4]}}
                                </p>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12 full-content  mb-4">
                            <h5  data-aos="fade-up">{{this.inclusivity.digitalinclusion}}</h5> 
                            <div class="custom_border">
                                <p  data-aos="fade-up" v-html="this.inclusivity.RichText5[0]">
                                    <!-- {{this.inclusivity.RichText5[0]}} -->
                                    <!-- {{this.inclusivity.RichText5[1]}} -->
                                </p>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-md-6 icons_section ml-auto mb-md-0 mb-4">
                            <div class="mx-500 mx-auto">
                                <div class="icons">
                                    <div class="icon"  data-aos="fade-up">
                                        <img :src="require(`../../assets/images/corporate-sustainability/svg/${this.inclusivity.IconSection[0].image}`)" alt="" class="img-fluid">
                                    </div>
                                </div>
                                <div class="custom_border ml-auto">
                                    <p v-html="this.inclusivity.IconSection[0].description"  data-aos="fade-up">
                                        {{this.inclusivity.IconSection[0].description}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"inclusivity",
    props:{
        inclusivity: Object
    }
}
</script>

<style lang="scss" scoped>
.inclusivity{
    .mx-500{
        max-width: 500px;
    }
    .pt-40{
        @media screen and (max-width:991px) {
            padding-top: 30px !important;
        }
         @media screen and (max-width:767px) {
            padding-top: unset !important;
        }
    }
    
    position: relative;
        &:after  {
            content: '';
            position: absolute;
            
            @include Background('../../assets/images/corporate-sustainability/inclusivity.jpg');
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -2;
        }
    /deep/{
        h5{
            font-size:rem(35px);
            color:#fff;
            font-weight:700;
            margin-bottom:rem(30px);
        }
    }
    .phase{
        padding:rem(40px) 0;
        h4{
            padding-left:0;
            @media screen and (max-width:767px){
                padding-left:15px;
            }
        }
        
        >div{
            margin-bottom:rem(60px) !important;
            padding: unset;
            padding-left:15px;
            padding-right:15px;
            @media screen and (max-width:767px){
                margin-bottom:rem(30px) !important;
            }
        }
    }
     .custom_border {
         ul {
             li{
                 &:before{
                     top:13px;
                 }
             }
         }
         &.bullets-green{
             ul{
                 li{
                     &:before{
                        background:#06a774;
                        top:13px;
                     }
                 }
             }
         }
     }
     p{
         /deep/{
             span{
                font-size:rem(30px);
                font-weight:900;
                @media screen and (max-width:1600px){
                    font-size:rem(25px);
                }
                @media screen and (max-width:575px){
                    font-size:rem(20px);
                }
            }
         }
     }
    h2{
        @include Heading(right)
    }
    h4{
        font-size: rem(25px);
        color: #fff;
        font-weight: bold;
        text-align: left;
        padding-left:45px;
    }   
    .icons{
       max-width:500px;
       margin-left:auto;
       margin-bottom:rem(20px);
    }
    .fullWidth{
        max-width: unset;
        .custom_border {
            max-width: unset;
        }
    }
    
    &.two{
         @include Background('../../assets/images/corporate-sustainability/generationyouth-banner2.jpg');
         padding-top:rem(50px);
         .litracy{
             padding-bottom:rem(60px);
             @media screen and (max-width:991px){
                 padding-bottom:rem(30px);
             }
             .icons_section{
                 margin-bottom:rem(30px);
                 img{
                     max-width:75px;
                 }
                 p{
                     padding-top:rem(16px);
                 }
             }
         }
         h4{
             max-width:500px;
             padding-left:0;
            margin-left: auto;
         }
    }
}

// arabic
    [lang="ar"] {
        .inclusivity{
            &:after  {
                 -webkit-transform: scaleX(-1);
                transform: scaleX(-1);
                right: 0;
                left: auto;
            }
            
            .phase{
                
                h4{
                    padding-right:0;
                    @media screen and (max-width:767px){
                        padding-right:15px;
                        padding-left:0;
                    }
                }
                
            }
            
            
            h2{
                @include Heading(left)
            }
            h4{
                text-align: right;
                padding-right:45px;
                padding-left: 0;
            }   
            .icons{
                margin-right:auto;
            }
            
            
            &.two{
               
                h4{
                    padding-right:0;
                    margin-right: auto;
                    margin-left: 0;
                }
            }
        }
    }
</style>